import React, { useEffect, useState, useRef } from "react";
import { Card, Row, Col, Alert, Spinner, ProgressBar } from "react-bootstrap";
import { Search, PencilSquare, Trash, Paperclip } from "react-bootstrap-icons";
import DataTable from "react-data-table-component";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useAppContext } from "providers/AppProvider";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import IconButton from "components/common/IconButton";
import {
  addValidationError,
  handleAddClaimNotes,
  handleFillStepData,
} from "features/cliams/config/claimSlice";
import { GetAllClaimPreAuthAllList } from "features/preauthorization/config/preauthorizationApi";
import ClaimDocumentRequest from "./ClaimDocumentRequest";
import DocumentUpload from "features/preauthorization/components/AddNoteClinicalNote";
import { toast } from "react-toastify";
import { compressPDF, toBase64, compressImage } from "../../utils.js";
const ClinicalDocumentRequest = ({
  control,
  setValue,
  watch,
  clearErrors,
  setError,
  errors,
}) => {
  const dispatch = useDispatch();
  const { stepFormData, claimNotes, claimRequestData, viewClaimInfo } =
    useSelector((state) => state.claim);
  const { investgationList } = useSelector((state) => state.preauthorization);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims",
  );
  const {
    config: { theme },
  } = useAppContext();

  const [originalFileName, setOriginalFileName] = useState("");
  const [isEditingInvestigation, setIsEditingInvestigation] = useState(false);
  const [selectedInvestigation, setSelectedInvestigation] = useState(null);
  const [fileValidationError, setFileValidationError] = useState("");
  const [compressionProgress, setCompressionProgress] = useState(0);
  const [compressionError, setCompressionError] = useState(null);
  const fileInputRef = useRef(null);

  const payloadClaim = viewClaimInfo?.payload_json;
  const subInfo = Object.values(payloadClaim?.sup_info ?? {});

  const claimRequest = claimRequestData?.entry?.find(
    (item) => item?.resource?.resourceType === "Claim",
  )?.resource;

  const status = viewClaimInfo?.claim_status;

  const isDisabled = [
    "invalid",
    "ready to submit",
    "rejected",
    "cancelled",
    "in process",
    "validation error",
    "invalid",
    "no response",
    "nores",
  ].includes(status?.toLowerCase());

  useEffect(() => {
    if (investgationList?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
  }, []);

  useEffect(() => {
    const additionalInfo =
      getVitalSignValue("info") ||
      subInfo?.find((item) => item?.addinfo)?.addinfo;
    const resultCode =
      subInfo?.find((item) => item?.invres)?.invres?.code ||
      getVitalSignValue("investigation-result") ||
      "";

    const resultDetails =
      subInfo?.find((item) => item?.invres)?.invres?.oth || "";

    const investigationResultValue = investgationList?.find(
      (item) => item?.investreslttype_code === resultCode,
    );

    const resultOthers =
      claimRequest?.supportingInfo?.find((entry) =>
        entry.category?.coding?.some((c) => c.code === "investigation-result"),
      )?.code?.text ||
      resultDetails ||
      "";

    if (
      watch("investigation_result")?.investreslttype_code !==
      investigationResultValue?.investreslttype_code
    ) {
      dispatch(
        handleFillStepData({
          check: "investigation_result",
          value:
            investigationResultValue || watch("investigation_result") || "",
        }),
      );
      setValue("investigation_result", investigationResultValue);
      setSelectedInvestigation(investigationResultValue);
    }

    if (watch("additional_information") !== additionalInfo) {
      dispatch(
        handleFillStepData({
          check: "additional_information",
          value: additionalInfo || "",
        }),
      );
      setValue("additional_information", additionalInfo || "");
    }

    if (watch("investigation_result_others") !== resultOthers) {
      dispatch(
        handleFillStepData({
          check: "investigation_result_others",
          value: resultOthers,
        }),
      );
      setValue("investigation_result_others", resultOthers);
    }

    const storedFile =
      claimRequest?.supportingInfo?.find((entry) =>
        entry.category?.coding?.some((c) => c.code === "attachment"),
      ) || subInfo?.find((item) => item?.invres)?.invres;

    if (
      (storedFile?.valueAttachment?.title || storedFile?.title) &&
      (originalFileName !== storedFile?.valueAttachment?.title ||
        originalFileName !== storedFile?.title)
    ) {
      setOriginalFileName(
        storedFile?.valueAttachment?.title || storedFile?.title,
      );
      setValue(
        "investgation_result_attachment",
        storedFile?.valueAttachment || storedFile,
      );
      dispatch(
        handleFillStepData({
          check: "investgation_result_attachment",
          value: storedFile?.valueAttachment || storedFile,
        }),
      );
    } else if (subInfo["19"]?.invres?.originalName) {
      setOriginalFileName(subInfo["19"]?.invres?.originalName);
    }
  }, [
    claimRequest,
    investgationList,
    dispatch,
    setValue,
    watch,
    originalFileName,
  ]);

  console.log({ investigation_result: watch("investigation_result") });

  const getVitalSignValue = (targetCode) => {
    const item = claimRequest?.supportingInfo?.find((entry) =>
      entry.category?.coding?.some((coding) => coding.code === targetCode),
    );

    if (item?.valueQuantity)
      return `${item?.valueQuantity?.value} ${item?.valueQuantity?.code}`;
    if (item?.valueDateTime) return item.valueDateTime;
    if (item?.code?.coding?.[0]?.code) return item.code.coding[0].code;
    if (item?.valueString) return item.valueString;
    return "";
  };

  const handleFileChange = async (file, onChange) => {
    if (!file) {
      onChange(null);
      setOriginalFileName("");
      setCompressionProgress(0);
      setCompressionError(null);
      clearErrors("investgation_result_attachment");
      return;
    }

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      setCompressionError("Only PDF or image files are allowed");
      dispatch(
        addValidationError({
          field: "investgation_result_attachment",
          message: "Only PDF or image files are allowed",
        }),
      );
      return;
    }

    setCompressionProgress(10);
    setCompressionError(null);

    try {
      let compressedFile = file;

      if (file.type === "application/pdf") {
        setCompressionProgress(40);
        compressedFile = await compressPDF(file);
        setCompressionProgress(80);
      } else if (file.type.startsWith("image/")) {
        compressedFile = await compressImage(file);
      }
      console.log({ compressedFile });
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (compressedFile.size > maxSize) {
        setCompressionError("Compressed file exceeds 10MB limit");
        dispatch(
          addValidationError({
            field: "investgation_result_attachment",
            message: "Compressed file exceeds 10MB limit",
          }),
        );
        setCompressionProgress(0);
        return;
      }

      const base64Data = await toBase64(compressedFile);

      const sanitizedName = file.name
        .replace(/\s+/g, "_")
        .replace(/\([^)]*\)/g, "")
        .replace(/[^\w.-]/g, "");
      const ext = sanitizedName
        .substring(sanitizedName.lastIndexOf("."))
        .toLowerCase();
      const hash = `${Date.now()}`;
      const title = `${hash}${ext}`;

      setOriginalFileName(file.name);

      onChange({
        contentType: compressedFile.type,
        title,
        originalName: file.name,
        size: compressedFile.size,
        creation: new Date().toISOString(),
        data: base64Data,
      });

      setCompressionProgress(100);
      clearErrors("investgation_result_attachment");
    } catch (error) {
      console.error("Compression error:", error);
      setCompressionError("Error processing file");
      dispatch(
        addValidationError({
          field: "investgation_result_attachment",
          message: "Error processing file",
        }),
      );
      setCompressionProgress(0);
    }
  };

  console.log({ stepFormData });
  const handleSaveInvestigation = () => {
    if (!selectedInvestigation) {
      toast.warning("Investigation result is required");
      return;
    }

    setValue("investigation_result", selectedInvestigation);
    dispatch(
      handleFillStepData({
        check: "investigation_result",
        value: selectedInvestigation,
      }),
    );

    const additionalInfo = watch("additional_information");
    if (additionalInfo) {
      dispatch(
        handleFillStepData({
          check: "additional_information",
          value: additionalInfo,
        }),
      );
    }

    if (selectedInvestigation?.investreslttype_code === "other") {
      const resultOthers = watch("investigation_result_others");
      if (!resultOthers) {
        setError("investigation_result_others", {
          type: "manual",
          message: "Investigation result details are required",
        });
        return;
      }
      dispatch(
        handleFillStepData({
          check: "investigation_result_others",
          value: resultOthers,
        }),
      );
    }

    if (selectedInvestigation?.investreslttype_code === "IRA") {
      const attachment = watch("investgation_result_attachment");
      if (!attachment) {
        toast.warning("Attachment is required");
        return;
      }
      dispatch(
        handleFillStepData({
          check: "investgation_result_attachment",
          value: attachment,
        }),
      );
    }

    setIsEditingInvestigation(false);
    setFileValidationError("");
  };

  const handleCancelInvestigation = () => {
    setSelectedInvestigation(watch("investigation_result"));
    setIsEditingInvestigation(false);
    clearErrors([
      "investigation_result",
      "investigation_result_others",
      "investgation_result_attachment",
    ]);
    setFileValidationError("");

    // Reset file input if needed
    if (
      fileInputRef.current &&
      watch("investigation_result")?.investreslttype_code !== "IRA"
    ) {
      fileInputRef.current.value = "";
      setOriginalFileName("");
    }
  };

  const handleDeleteRow = (id) => {
    dispatch(handleAddClaimNotes({ type: "delete", payload: { id } }));
  };

  const columns = [
    {
      name: "#",
      selector: (_, index) => index + 1,
      width: "50px",
      center: true,
    },
    {
      name: "Document Name",
      selector: (row) => row?.document_name || "-",
    },
    {
      name: "Notes",
      selector: (row) => row?.notes || "-",
      grow: 2,
      wrap: true,
    },
    {
      name: "Actions",
      button: true,
      cell: (row) => (
        <IconButton
          size="sm"
          variant="danger"
          onClick={() => handleDeleteRow(row?.id)}
          disabled={Number(claimsSetting?.submit) !== 1}
        >
          <Trash size={15} />
        </IconButton>
      ),
      width: "80px",
    },
  ];

  return (
    <>
      <Card className="h-100 border border-2 border-danger mb-3">
        <Card.Header className="d-flex badge-subtle-danger border-bottom border-danger justify-content-between align-items-center">
          <strong className="fs-12 text-danger">
            <Search className="me-2" />
            Investigation Result {isEditingInvestigation && "*"}
          </strong>
          {!isEditingInvestigation &&
          isDisabled &&
          Number(claimsSetting?.submit) === 1 ? (
            <PencilSquare
              onClick={() => {
                // setSelectedInvestigation(watch("investigation_result"));
                setValue("investigation_result", watch("investigation_result"));
                setIsEditingInvestigation(true);
              }}
              size={12}
              role="button"
              className="text-danger"
            />
          ) : isEditingInvestigation &&
            isDisabled &&
            Number(claimsSetting?.submit) === 1 ? (
            <div className="d-flex gap-2">
              <IconButton
                size="sm"
                variant="primary"
                onClick={handleCancelInvestigation}
              >
                Cancel
              </IconButton>
              <IconButton
                size="sm"
                variant="success"
                onClick={handleSaveInvestigation}
              >
                Save
              </IconButton>
            </div>
          ) : null}
        </Card.Header>
        <Card.Body className="p-2">
          {fileValidationError && (
            <Alert variant="danger" className="py-2 mb-2">
              {fileValidationError}
            </Alert>
          )}

          {isEditingInvestigation ? (
            <Row className="g-2">
              <Col xs={12} md={6}>
                <Controller
                  name="investigation_result"
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect
                      options={investgationList.map((item) => ({
                        value: item.investreslttype_code,
                        label: item.investreslttype_name,
                      }))}
                      value={
                        field.value
                          ? {
                              value: field.value.investreslttype_code,
                              label: field.value.investreslttype_name,
                            }
                          : null
                      }
                      onChange={(selected) => {
                        // ✅ FIXED: Correct key name
                        setValue(
                          "investigation_result",
                          selected
                            ? {
                                investreslttype_code: selected.value,
                                investreslttype_name: selected.label,
                              }
                            : null,
                        );
                        setSelectedInvestigation(
                          selected
                            ? {
                                investreslttype_code: selected.value,
                                investreslttype_name: selected.label,
                              }
                            : null,
                        );
                        handleFillStepData({
                          check: "investigation_result",
                          value: selected
                            ? {
                                investreslttype_code: selected.value,
                                investreslttype_name: selected.label,
                              }
                            : null,
                        });
                      }}
                      isClearable
                      placeholder="Choose..."
                    />
                  )}
                />
              </Col>

              {watch("investigation_result")?.investreslttype_code ==
                "other" && (
                <Col xs={12} md={6}>
                  <TextInput
                    name="investigation_result_others"
                    placeholder="Investigation Result Details"
                    control={control}
                    errors={errors}
                    rules={{
                      required: "Please provide investigation result details",
                    }}
                    size="sm"
                  />
                </Col>
              )}

              {watch("investigation_result")?.investreslttype_code ===
                "IRA" && (
                <Col xs={12} md={6}>
                  <Controller
                    name="investgation_result_attachment"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <div>
                        <TextInput
                          name={field.name}
                          label=""
                          type="file"
                          control={control}
                          required={true}
                          rules={{ required: true }}
                          errors={errors}
                          onChange={(file) =>
                            handleFileChange(file, field.onChange)
                          }
                          value={
                            originalFileName ||
                            field.value?.originalName ||
                            "Choose file..."
                          }
                        />
                        {compressionProgress > 0 &&
                          compressionProgress < 100 && (
                            <div className="text-center mt-2">
                              <ProgressBar
                                now={compressionProgress}
                                label={`${compressionProgress}%`}
                                className="mt-2"
                              />
                              <p className="mt-2 fs-10 mb-0">
                                Compressing file...
                              </p>
                            </div>
                          )}
                        {compressionError && (
                          <div className="text-danger mt-2 fs-10">
                            {compressionError}
                          </div>
                        )}
                      </div>
                    )}
                  />
                </Col>
              )}
            </Row>
          ) : (
            <div className="d-flex flex-column">
              <span className="fs-12 text-800 fw-bold">
                Investigation Result
              </span>
              <span className="fs-12 text-600">
                {stepFormData?.investigation_result?.investreslttype_name ||
                  "-"}
              </span>

              {watch("investigation_result")?.investreslttype_code ===
                "other" &&
                watch("investigation_result_others") && (
                  <div className="mt-2 d-flex flex-column">
                    <span className="fs-12 text-800 fw-bold">
                      Result Details
                    </span>
                    <span className="fs-12 text-600">
                      {typeof watch("investigation_result_others") === "string"
                        ? watch("investigation_result_others")
                        : watch("investigation_result_others")?.title || "-"}
                    </span>
                  </div>
                )}

              {watch("investigation_result")?.investreslttype_code === "IRA" &&
                originalFileName && (
                  <div className="mt-2 d-flex flex-column">
                    <span className="fs-12 text-800 fw-bold">Attachment</span>
                    <span className="fs-12 text-600 d-flex align-items-center">
                      <Paperclip size={12} className="me-1" />
                      {originalFileName}
                    </span>
                  </div>
                )}
            </div>
          )}

          <Row className="mt-2 g-2">
            <Col xs={12}>
              <Controller
                name="additional_information"
                control={control}
                defaultValue={stepFormData?.additional_information || ""}
                render={({ field }) => (
                  <TextInput
                    {...field}
                    multiline
                    rows={2}
                    control={control}
                    placeholder="Additional Information"
                    disabled={!isDisabled}
                    className="fs-12"
                    errors={errors}
                    onChange={(e) => {
                      field.onChange(e);
                      dispatch(
                        handleFillStepData({
                          check: "additional_information",
                          value: e,
                        }),
                      );
                    }}
                  />
                )}
              />
            </Col>

            {viewClaimInfo?.payload_json ? (
              <Col xs={12}>
                <ClaimDocumentRequest
                  watch={watch}
                  control={control}
                  isDisabled={isDisabled && Number(claimsSetting?.submit) === 1}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                />
              </Col>
            ) : (
              <Col xs={12}>
                <DocumentUpload
                  watch={watch}
                  control={control}
                  isDisabled={isDisabled && Number(claimsSetting?.submit) === 1}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                />
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>

      {claimNotes?.length > 0 && (
        <Card className="h-100 border border-2 mb-3">
          <Card.Body className="p-3">
            <DataTable
              columns={columns}
              theme={theme}
              data={claimNotes}
              responsive
              dense
              noHeader
            />
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default ClinicalDocumentRequest;
